<template>
  <div class="row" style="margin-left: 15px">
    <b-form @submit.prevent="onSubmit" v-if="show">
      <b-form-group
        id="label0"
        label="Tipo de Trabajo"
        label-for="input0"
        description="tipo de Trabajo Ejecutado "
      >
        <b-form-select
          v-model="form.trabajo_id"
          :options="OptionTrabajo"
          required
        />
      </b-form-group>
      <b-form-group
        id="label12"
        label="Ubicacion"
        label-for="input2"
        description="Ubicacion del Tramo"
      >
        <b-form-input
          id="input2"
          v-model="form.predata_ubicacion"
          :required="true"
        />
      </b-form-group>
      <b-form-group
        id="label3"
        label="Localidad"
        label-for="input2"
        description="Localidad que se encuentra el Tramo"
      >
        <b-form-input
          id="input3"
          v-model="form.predata_localidad"
          :required="true"
        />
      </b-form-group>
      <b-form-group
        id="label4"
        label="Zona"
        label-for="input4"
        description="Zona en que se encuentra el tramo"
      >
        <b-form-select
          v-model="form.predata_zona"
          :options="OptionZona"
          required
        />
      </b-form-group>
      <b-form-group
        id="label5"
        label="Region"
        label-for="input5"
        description="Region "
      >
        <b-form-select
          v-model="form.predata_region"
          :options="OptionRegion"
          required
        />
      </b-form-group>
      <b-form-group
        id="label6"
        label="Solicitante"
        label-for="input6"
        description="Quien solicito el trabajo"
      >
        <b-form-select
          id="input6"
          v-model="form.solicitante"
          :options="OptionSolicitantes"
          required
        />
      </b-form-group>

      <b-button type="submit" variant="primary">Siguiente</b-button>
    </b-form>
    <b-button v-show="!show" @click="volver" class="float-right" size="sm"
      >Volver</b-button
    >
    <hr style="border-color:red;" />
    <lavado
      v-if="idform === 1"
      :subcu="subcuenca"
      :identifica="tramo"
      :shal="shape_leng"
      :predata="form"
      :datos="datosprevios"
    ></lavado>
    <Inspeccion
      v-if="idform === 2"
      :subcu="subcuenca"
      :identifica="tramo"
      :shal="shape_leng"
      :predata="form"
      :datos="datosprevios"
    ></Inspeccion>
    <b-card v-show="idform === 0" title="Datos Previos">
      <b-list-group v-if="idform === 0 && state !== 0" style="margin-top: 10px">
        <b-list-group-item
          v-for="(lvd, index) in datoslvd"
          v-bind:key="index + 1"
          variant="primary"
          class="flex-column align-items-start">
          <div class="d-flex w-100 justify-content-between">
            <h5 class="mb-1">Lavado</h5>
            <small>{{new Date(lvd.lavado_fecha).toLocaleDateString()}}</small>
          </div>

          <p class="mb-1">
            <span @click="cargarDatos(lvd)" class="ti-pencil-alt"></span>
            <span @click="Eliminar(lvd,false)" class="float-right ti-trash"></span>
          </p>

          <small><strong>Solicitante:</strong>  {{lvd.predata.solicitanteL.solicitante_nombre}}</small>
        </b-list-group-item>
        <b-list-group-item
          v-for="(itv, index) in datositv"
          v-bind:key="index"
          variant="warning"
          class="flex-column align-items-start">
          <div class="d-flex w-100 justify-content-between">
            <h5 class="mb-1">Inspeccion</h5>
            <small>{{new Date(itv.inspeccion_fecha).toLocaleDateString()}}</small>
          </div>

          <p class="mb-1">
            <span @click="cargarDatos(itv)" class="ti-pencil-alt"></span>
            <span @click="Eliminar(itv,true)" class="float-right ti-trash"></span>
          </p>

          <small><strong>Solicitante:</strong>  {{itv.predata.solicitanteL.solicitante_nombre}}</small>
        </b-list-group-item>
      </b-list-group>
    </b-card>
  </div>
</template>

<script>
/* eslint-disable no-console */

import Http from "../Http";
import Lavado from "./Lavado";
import Inspeccion from "./inspeccion";
import EventBus from "../Bus"

export default {
  name: "formPredata",
  components: { Inspeccion, Lavado },
  props: ["tramo", "subcuenca", "shape_leng", "state"],
  computed: {
    OptionTrabajo() {
      return this.tipo.map(x => ({
        value: x.trabajo_id,
        text: x.trabajo_nombre
      }));
    },
    OptionSolicitantes() {
      return this.solicitantes.map(x => ({
        value: x.solicitante_id,
        text: x.solicitante_nombre
      }));
    },
    OptionZona() {
      return this.zonas.map(x => ({
        value: x.zona_id,
        text: x.zona_nombre
      }));
    },
    OptionRegion() {
      return this.regiones.map(x => ({
        value: x.region_id,
        text: x.region_nombre
      }));
    }
  },
  data: () => ({
    idform: 0,
    form: {
      trabajo_id: null,
      predata_ubicacion: null,
      predata_localidad: null,
      predata_zona: null,
      predata_region: null,
      solicitante: null
    },
    tipo: [],
    solicitantes: [],
    show: true,
    zonas: [],
    regiones: [],
    datoslvd: [],
    datositv: [],
    datosprevios: null
  }),
  mounted() {
    this.getTipodata();
    this.getdataTramo();
    if (this.state !== 0) {
      Http.Http()
        .get(`Informef/Lvd/${this.tramo}`)
        .then(resp => (this.datoslvd = resp.data))
        // eslint-disable-next-line no-console
        .catch(err => console.log(err));
      Http.Http()
        .get(`Informef/Itv/${this.tramo}`)
        .then(resp => (this.datositv = resp.data))
        // eslint-disable-next-line no-console
        .catch(err => console.log(err));
    }
  },
  methods: {
    Eliminar(data,itv){
      if(confirm("Realmente quiere eliminar el dato?")) {
        if(itv) {
          Http.Http().delete(`Informef/itv/${data.predata.predata_id}/${data.identifica}`)
            .then((resp) => {
              alert("se elimino de forma correcta!");
              EventBus.$emit("onPostdata", {id: data.identifica, state: resp.data});
            })
            .catch(err => console.log(err));
        }
        else{
          Http.Http().delete(`Informef/lvd/${data.predata.predata_id}/${data.identifica}`)
            .then((resp) => {
              alert("se elimino de forma correcta!");
              EventBus.$emit("onPostdata", {id: data.identifica, state: resp.data});
            })
            .catch(err => console.log(err));
        }
      }
    },
    getTipodata() {
      Http.Http()
        .get("Informef/trabajos")
        .then(x => {
          this.tipo = x.data;
        })
        .catch(err => console.log(err));
    },
    cargarDatos(datos) {
      if(confirm("Desea cargar los datos para editar?")) {
        let tmp = datos.predata;
        this.form.trabajo_id = tmp.trabajo_id;
        this.form.predata_ubicacion = tmp.predata_ubicacion;
        this.form.predata_localidad = tmp.predata_localidad;
        this.form.predata_zona = tmp.predata_zona;
        this.form.predata_region = tmp.predata_region;
        this.form.solicitante = tmp.solicitante;
        this.datosprevios = datos;
        Object.defineProperty(this.form, "predata_id", {
          value: tmp.predata_id,
          writable: true,
          enumerable: true,
          configurable: true
        });
        this.onSubmit();
      }
    },
    getdataTramo() {
      Http.Http()
        .get(`Informef/Gettradodata/${this.tramo}`)
        .then(x => {
          this.zonas.push(x.data.zonaD);
          this.regiones.push(x.data.regionD);
          this.form.predata_region = x.data.regionD.region_id;
          this.form.predata_zona = x.data.zonaD.zona_id;
          this.form.predata_ubicacion = x.data.tramotodata_direccion;
          this.form.predata_localidad = x.data.tramotodata_localidad;
          this.getSolicitante(x.data.zonaD.zona_id);
        })
        // eslint-disable-next-line no-console
        .catch(err => console.log(err));
    },
    getSolicitante(zona) {
      Http.Http()
        .get(`Informef/solicitante/${zona}`)
        .then(resp => {
          this.solicitantes = resp.data;
        })
        .catch(err => console.log(err));
    },
    volver() {
      this.show = true;
      this.idform = 0;
    },
    onSubmit() {
      switch (this.form.trabajo_id) {
        case 1:
          this.idform = 1;
          break;
        case 2:
          this.idform = 2;
          break;
        case 3:
          this.idform = 1;
          break;
        case 4:
          this.idform = 2;
          break;
        case 5:
          this.idform = 1;
          break;
        default:
          this.idform = 0;
          break;
      }
      this.show = false;
    }
  }
};
</script>

<style scoped></style>
